import cloneDeep from "lodash/cloneDeep";
import { getEventDesktop } from "../api/eventsApi";
import store from "../store/store";
export class FetchModalEventDataHelper {
  static fetchEventData = () => {
    const unsummarizedMarketsModalEventId: number = cloneDeep(
      store.getState().competitionListModel.unsummarizedMarketsModalEventId
    );
    const marketGroupType: string = cloneDeep(
      store.getState().competitionListModel.marketGroupType
    );
    return getEventDesktop(
      unsummarizedMarketsModalEventId,
      true,
      false,
      "ALL",
      null,
      marketGroupType
    )
      .then(eventData => {
        store.dispatch.competitionListModel.updateUnsummarizedMarketsModalEvent(
          eventData
        );
        store.dispatch.competitionListModel.updateUnsummarizedMarketsModalEventLoading(
          false
        );
      })
      .catch(error => {
        throw error;
      });
  };
}
